import { queryKeys } from "../queryKeys";
import {
  getOptionsContracts,
  type OptionContractsResponse,
} from "../rest/data";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetOptionContracts = ({
  assetSymbol,
  expirationDate,
  options,
}: {
  assetSymbol?: string;
  expirationDate?: string;
  options?: QueryOptions<OptionContractsResponse>;
}) =>
  useRequest(
    queryKeys.options.contracts(assetSymbol, expirationDate),
    () =>
      getOptionsContracts({
        underlying_symbol: assetSymbol,
        ...(expirationDate ? { expiration_date: expirationDate } : {}),
      }),
    {
      ...options,
    },
  );

export default useGetOptionContracts;
